import {ROLE_ADMIN, ROLE_SUPERADMIN, ROLE_USER} from "constants/admin"
import {del, get, patch, post, put} from "utils/api"

import {getTableFilters} from "./storage"

export const TABLE_USERS_LIST_NAME = "platform-users-list"

// REQUESTS

export async function getUsersRequest(params) {
  const { data } = await get("/admin/users", params, { rootRequest: true })
  return data
}

export async function updateUserRoleRequest(id, role) {
  const { data } = await patch(`/admin/users/${id}`, role, { rootRequest: true })
  return data
}

export async function getSpacesRequest(params) {
  const { data } = await get("/admin/spaces", params, { rootRequest: true })
  return data
}

function setIconField(data) {
  return Object.fromEntries(Object.entries(data).map(([key, value]) => {
    return key === "banner_icon" ? ["icon", value] : [key, value]
  }))
}

function setBannerIconField(data) {
  if (!Array.isArray(data)) return {
    ...data,
    banner_icon: data.icon,
    icon: undefined
  }
  return data.map(d => {
    return Object.fromEntries(Object.entries(d).map(([key, value]) => {
      return key === "icon" ? ["banner_icon", value] : [key, value]
    }))
  })
}

export async function getBannersRequest(params) {
  const { data } = await get("/admin/banner", params, { rootRequest: true })
  return setBannerIconField(data)
}

export async function createBannerRequest(bannerData) {
  const response = await post("/admin/banner", setIconField(bannerData), { rootRequest: true })
  const { status, data } = response
  if (status !== 200) throw new Error(`Create Banner failed with status ${response.status} - ${response.data}`)
  return setBannerIconField(data)
}

export async function updateBannerRequest(id, bannerData) {
  const response = await put(`/admin/banner/${id}`, setIconField(bannerData), { rootRequest: true })
  const { status, data } = response
  if (status === 200) return setBannerIconField(data)
  throw new Error(`Update banner failed with status ${response.status} - ${response.data}`)
}

export async function deleteBannerRequest(id) {
  const response = await del(`/admin/banner/${id}`, null, { rootRequest: true })
  if (response === undefined) return true // Its undefined as its returning 204
  const { status } = response
  if (status === 204) return true
  throw new Error(`Delete banner failed with status ${response.status}`)
}

export const getFilterQueryParams = (tableName, columns, username) => {
  const columnFilters = getTableFilters(tableName, username, true) || {}

  if (tableName === TABLE_USERS_LIST_NAME){
    return getUsersColumnFilterQuery(columnFilters, columns)
  }

  return getSpacesColumnFilterQuery(columnFilters, columns)
}

export function getUsersColumnFilterQuery(columnFilters={}) {
  let filters = {}
  for(let colKey in columnFilters) {
    const {[colKey]: colFilters=[]} = columnFilters
    //skip if column has no filters
    if (colFilters.length === 0) continue

    if (colKey === "id" || colKey === "email" || colKey === "role" ) {
      if (colFilters[0]?.value) {
        filters[colKey] = colFilters[0].value
      }
    } else if (colKey === "created_at") {
      filters["at"] = colFilters[0].value
    }
  }
  return filters
}

export function getSpacesColumnFilterQuery(columnFilters={}) {
  let filters = {}
  for(let colKey in columnFilters) {
    const {[colKey]: colFilters=[]} = columnFilters
    //skip if column has no filters
    if (colFilters.length === 0) continue

    if (colKey === "id" || colKey === "owner" ) {
      if (colFilters[0]?.value) {
        filters[colKey] = colFilters[0].value
      }
    } else if (colKey === "created_at") {
      filters["at"] = colFilters[0].value
    } else if (colKey === "allow_admin_access") {
      let filterValue = colFilters[0].value.toLowerCase()
      if (filterValue === "denied") {
        filterValue = false
      } else if (filterValue === "allowed") {
        filterValue = true
      }
      filters["allow_admin_access"] = filterValue
    } else if (colKey === "free") {
      let filterValue = colFilters[0].value.toLowerCase()
      if (["commercial", "false", false].includes(filterValue)) {
        filterValue = false
      } else if (["free trial", "true", true].includes(filterValue)) {
        filterValue = true
      }
      filters["free"] = filterValue
    }
  }
  return filters
}

export const hasColumnFilters = (tableName, username) => {
  const filters = getTableFilters(tableName, username, true)
  return Object.keys(filters).some(f => !!filters[f].length)
}
export const getSortQuery = sort => {
  const { direction, column } = sort
  let query
  switch (direction) {
  case "Ascending":
    query = `+${column}`
    break
  case "Descending":
    query = `-${column}`
    break
  default:
    break
  }
  return query? { sort: query } : {}
}

export const roleOptions = [
  {id: ROLE_SUPERADMIN, label: ROLE_SUPERADMIN},
  {id: ROLE_ADMIN, label: ROLE_ADMIN},
  {id: ROLE_USER, label: ROLE_USER},
]


export function isSuperadmin(swxRole) {
  return swxRole === ROLE_SUPERADMIN
}

export function isAdmin(swxRole) {
  return swxRole === ROLE_ADMIN
}

export const removeForbiddenHtmlTags = (str) => {
  if (str === null || str === "") return false
  else str = str.toString()
  // return str
  const ret = str.replace(/<\/?p>/gi, "")
  return ret
}